export default __webpack_public_path__ + "static/media/filterArrowDown.4822221c.svg";